import { render, staticRenderFns } from "./ErroSistema.vue?vue&type=template&id=6ca49ec4&scoped=true&"
import script from "./ErroSistema.vue?vue&type=script&lang=js&"
export * from "./ErroSistema.vue?vue&type=script&lang=js&"
import style0 from "./ErroSistema.vue?vue&type=style&index=0&id=6ca49ec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca49ec4",
  null
  
)

export default component.exports